export const RedirectTo = (url: URL) => {
    window.location.replace(url.toString());
};
